import React, { useState, useEffect, useRef } from 'react';
import { TextField, ButtonGroup, Button, Box } from '@mui/material';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const BoxSpecial = styled(MuiBox)(
    ({ theme, visible }) => ({
      opacity: visible?1:0,
      height: visible?'fit-content':0,
      transition: theme.transitions.create([ 'height', 'opacity' ], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      })
    }),
  );

export default function ButtonTimer ({ sendMessage, active, functionName, label }) {
    const intervalRef = useRef(null);
    const [ isActive, setIsActive ] = useState(false)
    const [ counter, setCounter ] = useState(0);
    const [ block, setBlock ] = useState(false);

    
    useEffect(() => {
        if (active) {
            handleStart();
        }
        setIsActive(active)
    }, [active])

    const handleStart = () => {
        setBlock(false)
        setCounter(10)
        if (intervalRef.current) return;
        intervalRef.current = setInterval( () => {
            setCounter(prev => {
                console.log('prev',prev)
                if(prev<=0){
                    
                    if(!block && isActive){
                        handleAccept()
                    }
                    handleAccept()
                    return 0;
                }
                return prev - 1;
            })
        }, 1000);
    };

    const handleAccept = () => {
        console.log('accept')
        const map = new Map()
        map.set('name','authSkill')
        map.set('function', {name: functionName, params: { action: 'accept' }})
        sendMessage(map)
        setIsActive(false)
        clearInterval(intervalRef.current);
        clearInterval.current = null
    }

    const handleAbort = () => {
        console.log('abort')
        const map = new Map()
        map.set('name','authSkill')
        map.set('function', {name: functionName, params: { action: 'abort' }})
        sendMessage(map)
        clearInterval(intervalRef.current);
        setBlock(true);
        setIsActive(false)
        clearInterval.current = null
    }


    return (
        <BoxSpecial visible={isActive}>
            <ButtonGroup elevation={10} variant="contained"  aria-label="Basic button group" >
                <Button onClick={ handleAccept }>{label} {counter}</Button>
                <Button onClick={ handleAbort }>Abort</Button>
            </ButtonGroup>
        </BoxSpecial>
        
    );
}